export default __webpack_public_path__ + "static/media/cp_geo_sj.cc842bf6.svg";